import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { viewRequestedQuotesAction } from '../../actions';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

function RequestedQuotesView({ viewRequestedQuotesAction }) {
    const [requestedQuotesData, setRequestedQuotesData] = useState(null);
    const params = useParams();
    const id = params.id;

    useEffect(() => {
        viewRequestedQuotesAction({ id: id }, (err, response) => {
            if (!err) {
                setRequestedQuotesData(response.data.data);
            }
        });
    }, [id, viewRequestedQuotesAction]);

    return (
        <div className="col-lg-12">
            <div className="card">
                {
                    requestedQuotesData ?
                        <>
                            <div className="header d-flex justify-content-between align-items-center">
                                <h2>
                                    {requestedQuotesData.title}
                                </h2>
                            </div>
                            <div className="body table-responsive">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th>Full Name:</th>
                                            <td>{requestedQuotesData.fullname}</td>

                                        </tr>
                                        <tr>
                                            <th>Email:</th>
                                            <td>{requestedQuotesData.email}</td>

                                        </tr>
                                        <tr>
                                            <th>Phone:</th>
                                            <td>{requestedQuotesData.phone}</td>

                                        </tr>
                                        <tr>
                                            <th>Postcode:</th>
                                            <td>{requestedQuotesData.postcode}</td>

                                        </tr>
                                        <tr>
                                            <th>Image:</th>
                                            <td><img width="60" src={requestedQuotesData.imagePath} className="rounded" /></td>
                                        </tr>
                                        <tr>
                                            <th>Order Description:</th>
                                            <td>{requestedQuotesData.orderDescription}</td>
                                        </tr>
                                        <tr>
                                            <th>Created At:</th>
                                            <td>{moment(requestedQuotesData.createdAt).format('YYYY-MM-DD hh:mm a')}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </> :
                        <div className="text-center">
                            <Loader
                                type="Bars"
                                color="#00BFFF"
                                height={100}
                                width={100}
                                timeout={3000} //3 secs
                            />
                        </div>

                }

            </div>
        </div>
    )
}

export default connect(null, { viewRequestedQuotesAction })(RequestedQuotesView)